/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import { connect } from 'react-redux'
import { withTranslation } from "react-i18next";
import { Tabs } from "antd";
import 'antd/dist/antd.min.css';

import Footer from 'components/common/Footer';
import MessageBox from 'components/common/MessageBox';
import * as types from 'reducer/actionTypes';
import { isEmpty } from 'script/common';

class Setting extends React.Component {
	componentWillMount() {
		this.props.fetchSettingDataInfo();
	}

	render() {
		const { t } = this.props;
		const TFL = "TF";
		const { uiCustomizationData } = this.props;
		const customizationData = uiCustomizationData || {};
		const licensePublisher = customizationData.publisher;
		const isPWL = customizationData.isPWL;

		const isNullCheck = (data) => {
			if (isEmpty(data)) return true;
			if (isEmpty(data.single) && isEmpty(data.multi)) return true;
			return false;
		}

		const defaultTap = 'settingService'


		// 탭 필터링
		const filteredTabs = this.props.tabs.filter(tab => {
			// TFL 라이선스이고, PWL 이 아닌 경우
			if (licensePublisher === TFL && !isPWL && tab.tabId === "settingUICustomization") {
				return false;  // settingUICustomization 탭 제외
			}
			return true;  // 나머지 탭은 그대로 유지
		});

		return (
			<div className="main">
				<h2>{t('cm.secondary.nav.label.settings')}</h2>
				<div className="content_box">
					<Tabs
						defaultActiveKey={defaultTap}
						type="card"
						size={this.props.tabs.size}
						items={filteredTabs.map((data, i) => {
							return {
								key: data.tabId,
								label: t(data.tabName),
								children: <data.component isNullCheck={(e) => isNullCheck(e)} alertMessage={this.props.alertMessage} />
							}
						})}
					/>
				</div>
				<MessageBox />
				{/* Footer 가 중복으로 출력됨 */}
				{/* <Footer /> */}
			</div>
		)
	}
}

// state를 해당 컴포넌트의 props로 연결
const mapStateToProps = (reducers) => {
	return {
		tabs: reducers.setting.tabs,
		error: reducers.setting.error,
		uiCustomizationData: reducers.setting.uiCustomizationData,
	}
}

// 컴포넌트의 함수형 poprs를 실행했을때, 지정한 action을 dispatch 하도록 설정
const mapDispatchToProps = (dispatch) => {
	return {
		alertMessage: (message) => { dispatch({ type: types.FETCH_MESSAGEBOX_REQUEST, message: message, isError: true }) },
		fetchSettingDataInfo: (key) => dispatch({ type: types.FETCH_GET_UI_CUSTOMIZATION_REQUEST, key }),
	}
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Setting))